import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import Loader from '../../common/Loader'
import Error from '../../common/Error'

import CategoryQuestions from './CategoryQuestions'
import styled from 'styled-components'
import BusinessQuery from '../queries/BusinessQuery'

const Wrapper = styled.div`
  margin: 20px;
`

class BusinessQuestions extends Component {
  get categories() {
    const { props: { type } } = this
    let allCategories = [
      'questions_prequalify',
      'questions_prequalify_paycheck_protection',
      'questions_basic_info',
      'questions_basic_info_payroll',
      'questions_payroll_revenue',
      'questions_story',
      'questions_payroll_info',
      'questions_payroll_funds',
      'questions_closing',
      'questions_business_closing_payroll',
      'questions_business_closing_payroll_ppp_second_draw'
    ]

    if (type === 'EpcBusiness') {
      allCategories = ['questions_closing']
    }

    return allCategories
  }
  getQuestionsByCategory = category => {
    const {
      props: { data: { business }, getQuestions }
    } = this

    return getQuestions(business)[category] || []
  }
  render() {
    const {
      props: { data, isEditable },
      getQuestionsByCategory,
      categories
    } = this
    const { loading, error } = data

    if (loading) {
      return <Loader number={4} />
    }
    if (error) {
      return <Error />
    }
    const { business } = data

    return (
      <Wrapper>
        {categories.map(category => {
          const questions = getQuestionsByCategory(category)

          if (questions.length > 0) {
            return (
              <CategoryQuestions
                key={`category-${category}`}
                entity={business}
                questions={questions}
                category={category}
                isEditable={isEditable}
              />
            )
          }
        })}
      </Wrapper>
    )
  }
}

export { BusinessQuestions }

export default graphql(BusinessQuery, {
  options: ({ entityId }) => ({
    variables: {
      entityId
    }
  })
})(BusinessQuestions)
